<template>
    <div class="join">
        <div class="list">
            <div class="title">组织信息</div>
            <van-field readonly clickable v-model="form.org_name" label="组织名称" @click="showPicker = true" placeholder="请选择" />
            <van-field readonly clickable v-model="form.month" label="所属月份" @click="showPicker2 = true" placeholder="请选择" />
            <van-field v-model="form.name" label="填报人" placeholder="请输入" />
            <van-field v-model="form.mobile" type="tel" label="手机号" placeholder="请输入" />
            <van-field v-model="form.explain" rows="1" autosize type="textarea" label="说明" placeholder="请输入" />
        </div>
        <div class="list" v-for="(item, index) in form2" :key="index">
            <div class="title">赛事活动信息表</div>
            <van-field v-model="form2[index].title" rows="1" autosize type="textarea" label="赛事名称" placeholder="请输入" />
            <van-field name="type" label="类型">
                <template #input>
                    <van-radio-group v-model="form2[index].type" direction="horizontal">
                        <van-radio :name="1">承办</van-radio>
                        <van-radio :name="2">参与</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field name="match_level" label="赛事等级">
                <template #input>
                   <van-radio-group v-model="form2[index].match_level" direction="horizontal">
                        <van-radio style="margin-bottom:.1rem" :name="1">全国</van-radio>
                        <van-radio style="margin-bottom:.1rem" :name="2">市级</van-radio>
                        <van-radio style="margin-bottom:.1rem" :name="3">区级</van-radio>
                        <van-radio style="margin-bottom:.1rem" :name="4">社区</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field v-model="form2[index].date" readonly clickable @click="changetime(index)" label="比赛时间" placeholder="请选择" />
            <van-field v-model="form2[index].num" label="参加人数" type="digit" placeholder="请输入" />
            <van-field v-model="form2[index].remark" rows="1" autosize type="textarea" label="备注" placeholder="请输入" />
        </div>
        <div class="list pdd">
            <van-button type="danger" :disabled="form2.length<=1" @click="cencel">删除赛事信息</van-button>
            <van-button type="primary" @click="add">新增赛事信息</van-button>
        </div>
        <div class="footer">
            <div class="btn" @click="submit">
                提     交
            </div>
        </div>
        <van-popup v-model="showPicker" position="bottom" :style="{ height: '100%' }">
            <van-field v-model="search.keywords" label="组织查找" @input="getlist" placeholder="请输入关键字搜索" />
            <div class="p-pop">
                <div class="p-title">
                    <div @click="showPicker = false">取消</div>
                    <div @click="onConfirm">确认</div>
                </div>

                <div class="plist">
                    <div :class="['item',form.orgid == item.id?'active':'']" v-for="item in columns" :key="item.id" @click="change(item)">{{item.name}}</div>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="showPicker2" round position="bottom">
            <van-picker
                show-toolbar
                :columns="arealist"
                @cancel="showPicker2 = false"
                @confirm="onConfirm2"
            />
        </van-popup>
        <van-calendar allow-same-day v-model="show" :min-date="minDate" type="range" @confirm="onConfirm3" color="#1989fa" />
    </div>
</template>

<script>
import moment from 'moment'
import { Cell, CellGroup,Field,RadioGroup, Radio,Calendar } from 'vant';

export default {
    components: {
       vanCell: Cell, vanCellGroup:CellGroup,vanField:Field,vanRadioGroup:RadioGroup,
       vanRadio: Radio, vanCalendar: Calendar
    },
    data() {
        return {
            search: {
                keywords: '',
                status: 1,
            },
            arealist: ['01','02','03','04','05','06','07','08','09','10','11','12'],
            form: {                
                org_name: '',
                orgid: '',
                year: moment().format('YYYY') * 1,
                month: '',  
                name: '',
                mobile: '',              
                explain: ''
            },
            data:{
                title: '',
                num: 0,
                type: 1,
                match_level: 1,
                start_time: '',
                date: '',
                end_time: '',              
                remark: ''
            },
            form2: [],
            type: 1,
            columns: [],
            showPicker: false,
            showPicker2: false,
            show: false,
            minDate: new Date(2023, 0, 1),
            index: 0
        }
    },
    mounted() {
        this.getlist()
        this.form2.push(this.data)
    },
    methods: {
        onConfirm(value) {
            if (this.form.orgid == '') {
                this.$dialog.alert({
                    title: '提示',
                    message: '请选择组织单位',
                })
                return
            }
            this.showPicker = false;
        },
        changetime(index){
            this.show = true
        },
        add() {
            this.form2.push(this.data)
        },
        cencel() {
            if(this.form2.length>1) 
                this.form2.pop()
        },
        onConfirm3(date) {
            const [start, end] = date;
            this.show = false;           
            let dates = new Date(start)
            let datee = new Date(end)
            this.form2[this.index].start_time = Date.parse(dates) / 1000
            this.form2[this.index].end_time = Date.parse(datee) / 1000
            this.form2[this.index].date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
        },
        formatDate(date) {
            return `${date.getMonth() + 1}-${date.getDate()}`;
        },
        onConfirm2(value) {
            if(!value) {
                this.$dialog.alert({
                    title: '提示',
                    message: '请选择月份',
                })
                return
            }
            this.form.month = value;
            this.showPicker2 = false;
        },
        getlist() {
            this.form.orgid = ''
            this.form.org_name = ''
            this.$api.system.orglist({search:this.search,pagesize:20}).then(res=>{
                this.columns = res.data.list
            })
        },
        change(item) {
            this.form.orgid = item.id
            this.form.org_name = item.name
        },
        submit() {
            if(this.form.org_name == '' || this.form.name == '' || this.form.month == '' || this.form.mobile == '') {
                this.$dialog.alert({
                    title: '提示',
                    message: '请补充完组织信息',
                })
                return
            }
            if(this.form2.findIndex(ele=> ele.title == '' || ele.start_time == '') !== -1) {
                this.$dialog.alert({
                    title: '提示',
                    message: '请补充完赛事活动信息',
                })
                return
            }
            var [...data] = this.form2
            data.forEach(item=>{
                item.num = item.num*1
                Object.assign(item,this.form)
            })

            this.$api.system.matchupdate({data:JSON.stringify(data)}).then(res=>{
                if (res.code == 200) {
                    this.$dialog.alert({
                        title: '提示',
                        message: '提交成功',
                    })
                    this.form2 = []
                    this.form2.push(this.data)
                    // this.$router.push({name:'sports'})
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.join{
    background: #F9F9F9;
    box-sizing: border-box;
    padding: .3rem;
    .list{
        background: #ffffff;
        border-radius: .08rem;
        padding-bottom: .1rem;
        margin-bottom: .2rem;
        .title{
            color: #333;
            font-size: .3rem;
            border-bottom: .01rem solid rgba(238,238,238,1);
            padding: .3rem;
        }
        .field{
            font-size: .28rem;
            box-sizing: border-box;
            padding: .2rem .3rem;
            border-bottom: .01rem solid rgba(238,238,238,1);
            .label{
                color: #646566;
                padding-bottom: .1rem;
            }
        }
        .box{
            padding: .3rem;
            .leabl{
                font-size: .28rem;
                color: #7C7F8E;
                padding-bottom: .3rem;
            }
            .checks{
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                justify-content: space-between;
                .check{
                    width: 3.1rem;
                    height: 1.98rem;
                    border-radius: .1rem;
                    background: #f5f5f5;
                    color: rgba(0,0,0,.65);
                    font-size: .24rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    img{
                        width: 1.1rem;
                        height: 1.1rem;
                    }
                }
                .active{
                    color: #025DF4;
                    background: #E6EFFE;
                }
                .check2{
                    border: .015rem solid rgba(238,238,238,1);
                    box-sizing: border-box;
                    padding: .16rem .28rem;
                    font-size: .28rem;
                    color: #7C7F8E;
                    margin-bottom: .28rem;
                    border-radius: .1rem;
                }
                .active2{
                    color: #025DF4;
                    background: #E6EFFE;
                    border: .015rem solid #025DF4;
                }
            }
        }
            
    }
    .pdd{
        margin-bottom: 2rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: .2rem;
    }
    .footer{
        .btn{
            width: 100%;
            height: .9rem;
            color: #ffffff;
            line-height: .9rem;
            text-align: center;
            background: #025DF4;
            border-radius: .12rem;
        }
    }
    .tips{
        font-size: .28rem;
        color: #025DF4;
        padding: .2rem .3rem 0;
    }
    .p-pop{
        font-size: .26rem;
        box-sizing: border-box;
        padding: .3rem;
        width: 100%;
        .p-title{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: .2rem;
            >div{
                box-sizing: border-box;
                padding: .1rem .2rem;
            }
            >div:nth-child(2) {
                color: #025DF4;
            }
        }
        .plist{
            .item{
                // margin-bottom: .1rem;
                box-sizing: border-box;
                padding: .1rem 0;
            }
            .active {
                color: #025DF4;
            }
        }
    }
}
</style>